<template>
  <div class="roles">
    <div class="personnels-main" v-if="change == 0">
      <div class="asset-page-content">
        <div class="intro-y box p-5 mt-5">
          <div class="personnels-title">角色管理</div>
          <div class="search-form">
            <el-form :form="form" :inline="true">
              <el-form-item label="角色名称:">
                <el-input v-model='form.name' placeholder="请输入角色名称" style="width:230px;"/>
              </el-form-item>
              <el-form-item label="启用状态:">
                <el-select style="width: 140px" v-model='form.status' @change="sourceChange" placeholder="请选择">
                  <el-option
                      v-for="item in unitOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" style="margin-right:10px;" @click="seek" :loading="loading">
                  提交
                </el-button>
                <el-button type="primary" @click="addAsset">
                  +新增角色
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <table class="table table-report mt-2">
          <thead>
          <tr>
            <th class="whitespace-no-wrap">角色名称</th>
            <th class="whitespace-no-wrap">角色描述</th>
            <th class="whitespace-no-wrap">启用状态</th>
            <th class="whitespace-no-wrap">创建时间</th>
            <th class="whitespace-no-wrap">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(item, index) in modele"
              :key="index"
              class="intro-x"
          >
            <td>
              <div class="font-medium whitespace-no-wrap">{{
                  item.name
                }}
              </div>
            </td>
            <td>
              <div class="font-medium whitespace-no-wrap">{{
                  item.description
                }}
              </div>
            </td>
            <td>
              <div class="font-medium whitespace-no-wrap">{{
                  item.status ? '是' : '否'
                }}
              </div>
            </td>
            <td>
              <div class="font-medium whitespace-no-wrap">{{
                  item.createTime
                }}
              </div>
            </td>
            <td class="table-report__action whitespace-no-wrap">
              <div class="flex  items-center">
                <a class="flex items-center mr-3" href="javascript:;" v-if="item.status" @click='changeStatus(item)'>
                  关闭
                </a>
                <a class="flex items-center mr-3" href="javascript:;" v-else @click='changeStatus(item)'>
                  启动
                </a>
                <a class="flex items-center mr-3" href="javascript:;" @click='checkHandle(item)'>
                  编辑
                </a>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div
          class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center justify-space-between mt-5"
      >
        <el-pagination
            layout="prev, pager, next"
            :background='false'
            :page-size="pagination.perPage"
            :current-page="pagination.page"
            @current-change="handleTableChange"
            :total="pagination.total">
        </el-pagination>
        <select class="w-20 input box mt-3 sm:mt-0" @change='onShowSizeChange' v-model='pagination.perPage'>
          <option :value='10'>10</option>
          <option :value='25'>25</option>
          <option :value='35'>35</option>
          <option :value='50'>50</option>
        </select>
      </div>
    </div>
    <div class="intro-y box p-5 mt-5" v-if="change == 1">
      <div class="asset-page-content" style="display: flex;padding: 10px 0 0 0">
        <div class="add-l">
          <div class="add-title">{{ fex }}人员</div>
        </div>
        <div class="add-r">
          <div style="line-height: 46px;font-size: 20px;font-weight: bold;padding-bottom: 10px;">人员信息</div>
          <div>
            <el-form
                ref="ruleForm"
                :model="ruleForm"
                :rules="rules"
                :wrapper-col="wrapperCol"
                label-width='100px'
            >
              <el-form-item label="角色名称：" prop='name'>
                <el-input v-model="ruleForm.name" style="width: 450px" placeholder="请输入角色名称"/>
              </el-form-item>
              <el-form-item label="角色描述：">
                <el-input v-model="ruleForm.description" style="width: 450px" type="textarea"/>
              </el-form-item>
              <el-form-item label="启用状态："  prop='status'>
                <el-radio-group v-model="ruleForm.status" style="padding-left: 10px">
                  <el-radio label="1" name="type">
                    启用
                  </el-radio>
                  <el-radio label="0" name="type">
                    停用
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item style="margin-bottom: 10px" label="权限管理：" prop='permissionIdList' labelAlign="left">
                <el-tree
                    :props="props"
                    node-key="key"
                    show-checkbox
                    default-expand-all
                    @check="checkChange"
                    :default-checked-keys="selectedKeys"
                    :data="treeData"
                />
              </el-form-item>
              <el-form-item style="padding-left: 100px;padding-top: 10px">
                <el-button @click="submitData();">
                  确定
                </el-button>
                <el-button type="primary" @click="changeFex()" style="margin-left: 10px;">
                  取消
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getRoleList, toggleRole, getPermissionList, getDetailUser, updateUser, addUsert} from "../../api/organization";

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];
export default {
  name: "personnels",
  components: {},
  data() {
    return {
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      treeData: [],
      originaNumber: [],
      disabled: false,
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      ruleForm: {
        name: '',
        description: '',
        status: '0',
        permissionIdList: [],
      },
      missionIdList: [],
      props:{
        label:'title',
        children:'children'
      },
      rules: {
        name: [
          {required: true, message: '请输入角色名称', trigger: 'blur'},
        ],
        status: [
          {required: true, message: '请输入角色名称', trigger: 'blur'},
        ],
        permissionIdList: [
          {required: true, message: '请选择权限', trigger: 'blur'},
        ],
      },
      change: 0,
      fex: "新增",
      unitOptions: [
        {id: '', name: '全部状态'},
        {id: '0', name: '未启用'},
        {id: '1', name: '启用'},
      ],
      form: {
        name: '',
        status: '',
      },
      pagination: {
        page: 1,
        total: 0,
        perPage: 10,
      },
      loading: false,
      modele: [],
    }

  },
  methods: {
    //清除验证
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    handleChange(nextTargetKeys, direction, moveKeys) {
      this.targetKeys = nextTargetKeys;
      console.log(this.mockData)
      console.log(this.targetKeys)
    },
    //查找
    seek() {
      this.pagination.page = 1;
      this.getList();
    },
    onShowSizeChange(e) {
      this.pagination.page = 1;
      this.getList();
    },
    //拉取列表
    getList() {
      let para = this.form;
      para.page = this.pagination.page;
      para.perPage = this.pagination.perPage;
      this.loading = true;
      getRoleList(para).then(res => {
        this.loading = false
        let data = res.data
        if (data.code === '000') {
          this.modele = data.content.list;
          this.pagination.total = data.content.total;
        } else {

        }
      }).catch(err => {
        this.loading = false
        console.log(err);
      }).finally(() => {
        this.loading = false
      })
    },
    //修改状态
    changeStatus(data) {
      let para = '';
      if (data.status) {
        para = {
          id: data.id,
          status: false,
        };
      } else {
        para = {
          id: data.id,
          status: true,
        };
      }
      toggleRole(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.$message.success('修改成功');
          this.getList();
        } else {
          this.$message.error(data.desc);
        }
      }).catch(err => {
        this.loading = false
        console.log(err);
      }).finally(() => {
        this.loading = false
      })
    },

    submitData() {
      // this.handleNumber();
      this.ruleForm.permissionIdList = this.selectedKeys
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let para = this.ruleForm;
          this.ruleForm.status = Number(this.ruleForm.status);
          if (this.fex == '修改') {
            updateUser(para).then(res => {
              let data = res.data;
              if (data.code === '000') {
                this.$message.success('修改成功');
                this.changeFex();
                this.getList();
              } else {
                this.$message.error(data.desc);
              }
            }).catch(err => {
              console.log(err);
            }).finally(() => {

            })
          } else {
            addUsert(para).then(res => {
              let data = res.data;
              if (data.code === '000') {
                this.$message.success('添加成功');
                this.changeFex();
                this.getList();
              } else {
                this.$message.error(data.desc);
              }
            }).catch(err => {
              console.log(err);
            }).finally(() => {

            })
          }
        } else {
          return false;
        }
      });
    },
    //数据处理
    // handleNumber(num) {
    //   let arr = this.missionIdList;
    //   let arrList = [];
    //   for (let i = 0; i < arr.length; i++) {
    //     for (let j = 0; j < this.originaNumber.length; j++) {
    //       if (arr[i] == this.originaNumber[j].id) {
    //         if (this.originaNumber[j].parentId && this.originaNumber[j].parentId != '-1') {
    //           arrList.push(this.originaNumber[j].parentId);
    //         }
    //       }
    //     }
    //   }
    //   let yes = this.mergeArray(this.unique(arrList), this.unique(this.missionIdList))
    //   this.ruleForm.permissionIdList = yes;
    // },
    unique(arr) {
      for (var i = 0, len = arr.length; i < len; i++) {
        for (var j = i + 1, len = arr.length; j < len; j++) {
          if (arr[i] === arr[j]) {
            arr.splice(j, 1);
            j--;        // 每删除一个数j的值就减1
            len--;      // j值减小时len也要相应减1（减少循环次数，节省性能）
            // console.log(j,len)

          }
        }
      }
      return arr;
    },
    mergeArray(arr1, arr2) {
      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i] === arr2[j]) {
            arr1.splice(i, 1); //利用splice函数删除元素，从第i个位置，截取长度为1的元素
          }
        }
      }
      for (var i = 0; i < arr2.length; i++) {
        arr1.push(arr2[i]);
      }
      return arr1;
    },
    //切换到添加修改
    changeFex() {
      this.change = 0;
      this.resetForm();
    },
    changeFex2() {
      this.change = 1;
    },
    addAsset() {
      this.fex = '新增';
      this.changeFex2();
      this.ruleForm = {
        name: '',
        description: '',
        status: '0',
        permissionIdList: [],
      };
      this.missionIdList = [];
    },
    checkHandle(record) {
      this.fex = '修改';
      this.changeFex2();
      this.ruleForm = {
        name: '',
        description: '',
        status: '0',
        permissionIdList: [],
      };
      this.missionIdList = [];
      let para = {
        id: record.id,
      }
      getDetailUser(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.ruleForm = data.content;
          let orginArr = [];
          let bol = false
          for (let i = 0; i < data.content.permissionIdList.length; i++) {
            bol = false
            for (let j = 0; j < this.expandedKeys.length; j++) {
              if (data.content.permissionIdList[i] == this.expandedKeys[j]) {
                bol = true
              }
            }
            if (!bol) {
              orginArr.push(data.content.permissionIdList[i])
            }
          }
          // console.log(orginArr);
          this.missionIdList = this.selectedKeys= this.unique(orginArr);
          // console.log(this.missionIdList,999);
          if (data.content.status) {
            this.ruleForm.status = '1';
          } else {
            this.ruleForm.status = '0';
          }
        } else {
          this.$message.error(data.desc);
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {

      })
    },
    toggle() {
      console.log(this.form)
    },
    handleTableChange(page) {
      console.log(page)
      this.pagination.page = page;
      this.getList();
    },
    sourceChange(val) {
      
    },
    //权限
    // onExpand(expandedKeys) {
    //   console.log('onExpand', expandedKeys);
    //   this.expandedKeys = expandedKeys;
    //   this.autoExpandParent = false;
    // },
    // onCheck(checkedKeys) {
    //   console.log('onCheck', checkedKeys);
    //   this.ruleForm.permissionIdList = checkedKeys;
    // },
    // onSelect(selectedKeys, info) {
    //   console.log('onSelect', info);
    //   this.selectedKeys = selectedKeys;
    // },
    checkChange(a,b){
      console.log(b)
      this.selectedKeys = b.checkedKeys
      if(this.selectedKeys.length >0){
        this.$refs.ruleForm.clearValidate(['permissionIdList'])
      }
    },
    //获取权限
    toTreeData(arr, id, pid, name) {
      // 建立个树形结构,需要定义个最顶层的父节点，pId是1
      let parent = [];
      this.expandedKeys = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].parentId == "-1") {
          let obj = {
            title: arr[i].authorityName,
            key: arr[i].id,
            children: []
          };
          this.expandedKeys.push(arr[i].id);
          parent.push(obj);//数组加数组值
        } else {

        }

      }
      this.children(parent);
    },
    // 调用子节点方法,参数为父节点的数组
    children(parent) {
      let array = this.treeData
      if (array.length !== 0) {
        for (let i = 0; i < parent.length; i++) {
          for (let j = 0; j < array.length; j++) {
            if (parent[i].key == array[j].parentId) {
              let obj = {
                title: array[j].authorityName,
                key: array[j].id,
                children: []
              };
              parent[i].children.push(obj);
            }
          }
          // this.children(parent[i].children);
        }
      }
      
      this.treeData = parent
    },
    getPermission() {
      getPermissionList().then(res => {
        let data = res.data;
        if (data.code === '000') {
          let arr = data.content.list;
          this.originaNumber = arr;
          this.treeData = arr;
          this.toTreeData(arr, "id", "parentId", "authorityName")
        } else {

        }
      }).catch(err => {
        this.loading = false
        console.log(err);
      }).finally(() => {
        this.loading = false
      })
    },


  },
  watch: {
    checkedKeys(val) {
      console.log('onCheck', val);
    },
  },
  created() {
    this.getList();
    this.getPermission();
  },
}
</script>

<style scoped lang="scss">
.personnels-title {
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 20px;
  padding-top: 20px;
}

.search-form {

}

.add-l {
  width: 200px;

  .add-title {
    background-color: #e9f7fe;
    line-height: 46px;
    padding-left: 25px;
    font-size: 14px;
    border-right: 3px solid #4390f7;
    color: #4390f7;
  }
}

.add-r {
  flex: 1;
  padding-left: 25px;
  border-left: 1px solid rgba(235, 235, 235, 1);
}

</style>
